export default {
  action: {
    compare: {
      notes: 'Label of action to perform compare',
      message: 'Compare',
    },
    showCurrentOnly: {
      notes: 'Label of action to remove comparison and show only current data',
      message: 'Show current only',
    },
  },
  period: {
    previousDay: {
      notes: 'Compare with previous day',
      message: 'Previous day',
    },
    previousWeek: {
      notes: 'Compare with previous week',
      message: 'Previous week',
    },
    notSupported: {
      notes:
        'Information that compare period is not supported. For example, previous day is not supported when viewing data for last seven days.',
      message: 'Select a shorter time window to compare data',
    },
  },
};
